<template>
  <v-dialog
    v-if="!loadingData"
    v-model="show"
    max-width="600"
    overlay-color="darktext"
    overlay-opacity="0.6"
    disabled
  >
    <v-card
      class="pa-5"
    >
      <v-card-title class="pb-8">
        {{ $t('owners') }}

        <v-spacer />
        <v-icon
          ref="cancel"
          data-testid="cancel-button"
          min-width="100"
          class="rounded-xxl text-none pa-0"
          style="position: absolute; right: 24px; top: 24px;"
          @click="$emit('close')"
        >
          mdi-close
        </v-icon>
     </v-card-title>
      <v-divider />
      <div style="height:300px; overflow-y:auto;">
        <div       
          v-for="(user, index) in users"
          :key="index"
          class="list-item"
        >
          <v-list-item>
            <v-list-item-avatar>
              <v-avatar
                size="56"
                class="white--text"
              >
                <img
                  v-if="user.attributes.avatar_thumb == null"
                  :src="defaultImage"
                >
                <img
                  v-else
                  :src="`${user.attributes.avatar_thumb}`"
                >
              </v-avatar>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>{{ user.attributes.first_name }} {{ user.attributes.last_name }}</v-list-item-title>
              <v-list-item-subtitle
                class="pt-0"
              >
                {{ user.attributes.email }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </div>

        <div
          v-if="users.length"
          v-observe-visibility="handleScrolledToBottom"
          class="text-center"
        >
          <v-progress-circular
              v-if="pageNumber < lastPage"
              size="24"
              color="primary"
              class="bottom py-5"
            />
      </div>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import { getBoostersInActivityAsMember } from '../api/activityApi'

export default {
    props: {
      visible: Boolean,
    },
    data(){
        return{
          users:[],
          usersInfo:[],
          activityId: this.$route.params.id,
          loadingData:false,
          pageNumber: 1,
          size: 5,
          lastPage: 1,
          defaultImage: require('../assets/user_images/profile-avatar.png'),
        }
      },  
      computed: {
          show: {
              get () {
                  return this.visible
              },
              set (value) {
                  if (!value) {
                      this.$emit('close')
                  }
              }
          },

      },

    async created(){
      this.loadingData = true
      await this.fetchOwnersInActivity()
      this.loadingData = false
    },
    methods: {
      handleScrolledToBottom (isVisible) {
        if (!isVisible) {
          return
        }
        if (this.pageNumber >= this.lastPage) {
          return
        }
        this.pageNumber++
        this.fetchOwnersInActivity()
      },
      async fetchOwnersInActivity(){
            try {
                const response = await getBoostersInActivityAsMember(this.activityId, this.pageNumber, this.size)
                if(response.status){
                    if(response.status == 200) {
                        this.users.push(...response.data.data)
                        this.usersInfo = response.data.meta
                        this.lastPage = response.data.meta.lastPage
                    }
                }
            } catch (e) {
                if(e.response){
                    if(e.response.status == 403){
                        this.$router.push({name: 'PageAccessDenied'})
                    } else if(e.response.status == 404) {
                         this.$router.push({name: 'PageNotFound'})
                    } else {
                        this.$emit('proceedError')
                    }
                }
            }
        },
     }
}
</script>
